import * as API_HOME from '../../api/home'

export default {
  namespaced: true,
  state: {
    modelList: [],
    dealmodelId: '',
    downmodelId: '',
    config: {
      address: '',
      agentConsultPhone: '',
      beianCode: '',
      bidConsultPhone: '',
      blockChainVerifyUrl: '',
      closeTheDealNum: '',
      cmsLoginUrl: '',
      cmsRegisterUrl: '',
      cmsRegisterUrlCloseHBMain: '',
      cmsRegisterUrlOpenHBMain: '',
      copyright: '',
      defaultSelectProvince: '',
      ebProject: '',
      electronicGuaranteeUrl: '',
      email: '',
      gpProject: '',
      phone: '',
      putOnRecord: '',
      registerUserNum: '',
      servicePhone: '',
      technicalSupport: '',
      websiteVisitCount: ''
    }
  },
  mutations: {
    model (state, payload) {
      state.modelList = payload.modelList
      state.dealmodelId = payload.dealmodelId
      state.downmodelId = payload.downmodelId
      localStorage.setItem('modelId', state.dealmodelId)
      localStorage.setItem('downmodelId', state.downmodelId)
    },
    setCmsConfig (state, config) {
      state.config.address = config.address
      state.config.agentConsultPhone = config.agentConsultPhone
      state.config.beianCode = config.beianCode
      state.config.bidConsultPhone = config.bidConsultPhone
      state.config.blockChainVerifyUrl = config.blockChainVerifyUrl
      state.config.closeTheDealNum = config.closeTheDealNum
      state.config.cmsLoginUrl = config.cmsLoginUrl
      state.config.cmsRegisterUrl = config.cmsRegisterUrl
      state.config.cmsRegisterUrlCloseHBMain = config.cmsRegisterUrlCloseHBMain
      state.config.cmsRegisterUrlOpenHBMain = config.cmsRegisterUrlOpenHBMain
      state.config.copyright = config.copyright
      state.config.defaultSelectProvince = config.defaultSelectProvince
      state.config.ebProject = config.ebProject
      state.config.electronicGuaranteeUrl = config.electronicGuaranteeUrl
      state.config.email = config.email
      state.config.gpProject = config.gpProject
      state.config.phone = config.phone
      state.config.putOnRecord = config.putOnRecord
      state.config.registerUserNum = config.registerUserNum
      state.config.servicePhone = config.servicePhone
      state.config.technicalSupport = config.technicalSupport
      state.config.websiteVisitCount = config.websiteVisitCount
      state.config.zxbPutOnRecord = config.zxbPutOnRecord
      state.config.zxbCopyright = config.zxbCopyright
      state.config.zxbPutOnRecordUrl = config.zxbPutOnRecordUrl
      state.config.zxbEnterFor = config.zxbEnterFor
      state.config.jcUrl = config.jcUrl
      state.config.loginUrl = config.loginUrl
      state.config.registerUrl = config.registerUrl
    }
  },
  actions: {
    model (context, payload) {
      return API_HOME.getAllCmsModel().then(res => {
        var dealmodelId = ''
        var downmodelId = ''
        res.data.forEach(val => {
          if (val.modelShortName === 'dealMore') {
            dealmodelId = val.modelId
          }
          if (val.modelShortName === 'down') {
            downmodelId = val.modelId
          }
        })
        context.commit('model', {
          modelList: res.data,
          dealmodelId: dealmodelId,
          downmodelId: downmodelId
        })
      })
    },
    setCmsConfig (context, config) {
      context.commit('setCmsConfig', config)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/module.js